import React from 'react'
import styled from '@emotion/styled'
import { BrowserUtils } from '../../utils/siteUtils'
import { ToggleSelect } from '../generic/questions'
import ConditionPage from './ConditionPage'
import ConditionSvgs from './ConditionSvgs'
import IconSvgs from './IconSvgs'

export default ({ prospectDocuments, bodyStyle, interiorSeatRows, ...props }) => {
  const isDesktop = BrowserUtils.isDesktop()
  const svgItems = ['Interior' + interiorSeatRows]
  const svgIcons = ['ABS', 'Airbags', 'Check Engine', 'Service Engine', 'Low Coolant', 'Maintenance', 'Oil Pressure']
  const movedQuestions = ['qp/65']
  const conditionQuestions = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qc').items.filter(item => item.section === 'Vehicle Condition')
  const title = conditionQuestions && conditionQuestions[0] ? conditionQuestions[0].section : 'n/a'
  // US522106 pick out odor question transform it into a ToggleSelect type button instead of a Boolean for display purposes
  const odorQuestion = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qp').items.find(q => q.questionId === 'qp/65')
  const toggleOdor = { ...odorQuestion, label: 'Has noticable odors', questionType: 'ToggleSelect', item: 'qp/65', subsectionCode: 'Odors' }
  conditionQuestions.push(toggleOdor)

  return (
    <ConditionPage {...{ title, conditionQuestions, svgItems, svgIcons, movedQuestions, ...props }} pageName={'interior'} noDamage={'No interior wear or damage and no issues with warning lights? Select Next.'}>
      <ConditionSvgs width={isDesktop ? 500 : 400} height={isDesktop ? 400 : 320} addMolding={true} {...{ svgItems, conditionQuestions, bodyStyle, ...props }}>
        <OdorWrapper>
          <ToggleSelect {...{ question: toggleOdor, subTextOverride: '(maybe from smoking, pets or mold)', ...props }} />
        </OdorWrapper>
      </ConditionSvgs>
      <IconSvgs {...{ conditionQuestions, svgIcons, ...props }} />
    </ConditionPage>
  )
}

const OdorWrapper = styled.div`
  margin-top: 25px;
`
